import * as React from 'react';

import { Price } from '@notino/react-styleguide-v20';

import { useFormattedPrice } from '@hooks';
import { ReactFCV } from '@types';

import { UnitPriceWrapper } from './styled';

export interface IUnitPrice {
  price: number;
  unitAmount: number;
  unit: string;
}

export const UnitPrice: ReactFCV<IUnitPrice> = ({ price, unitAmount, unit }) => {
  const formattedPrice = useFormattedPrice(price);
  return (
    <UnitPriceWrapper>
      <Price priceSize="0.625rem" currencySize="0.625rem" {...formattedPrice} />
      {`\u00A0/\u00A0${unitAmount}\u00A0${unit}`}
    </UnitPriceWrapper>
  );
};
